import { render, staticRenderFns } from "./NftForm.vue?vue&type=template&id=30b04e3b&scoped=true&"
import script from "./NftForm.vue?vue&type=script&lang=js&"
export * from "./NftForm.vue?vue&type=script&lang=js&"
import style0 from "./NftForm.vue?vue&type=style&index=0&id=30b04e3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b04e3b",
  null
  
)

export default component.exports